var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default"}),_c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }